import React, { useState, useEffect } from 'react';
import { Typography, Button } from '@mui/material';
import '../Reusable/ProgressButton/ProgressButton.css';

interface ProgressButtonProps {
    percentage: number;
    status: string; // "in-progress" or "completed"
}

const ProgressButton = ({ percentage, status }: ProgressButtonProps) => {
    const [progress, setProgress] = useState(percentage);
    console.log("percentage", percentage, progress)

    useEffect(() => {
        if (percentage) {
            const interval = setInterval(() => {
                setProgress((prev:any) => (prev < 100 ? prev + 1 : prev));
            }, 50); 
            return () => clearInterval(interval);
        } else if (percentage === 100) {
            setProgress(100); 
        }
    }, [percentage]);

    return (
        <div className="progress-container">
            <Button className="button-progress" style={{ position: 'relative', overflow: 'hidden' }}>
                {/* Progress bar background */}
                <span
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: `${percentage}%`,
                        background: 'linear-gradient(90deg, rgba(255,255,255,0.2), rgba(255,255,255,0.1))',
                        transition: 'width 0.3s ease',
                        zIndex: 1
                    }}
                ></span>
                {/* Button text */}
                 <Typography className="progress-text">
                {percentage > 0 && percentage < 100 ? ` ${Math.floor(percentage)}% In Progress...` : percentage === 100 ? 'Completed Video' : 'In Progress'}
            </Typography>
            </Button>
        </div>
    );
};

export default ProgressButton;
